// Libs
import React, { Component } from 'react'

// Containers
import eulaContainer from '../containers/Eula'

// Components
import FormField from '@react-mdc/form-field'
import Button from '@react-mdc/button'

// Constants
// import { SUPPORT_EMAIL } from './../constants'

// Styles
const styles = {
  text: {
    backgroundColor: 'white',
    padding: '16px',
    fontSize: 13,
    lineHeight: '17px',
  },
  heading: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    textAlign: 'center',
    paddingVertical: 10,
  },
  bold: {
    fontWeight: 'bold',
  },
  list: {
    padding: 16,
  },
  indent1: {
    textIndent: 8,
  },
  indent2: {
    marginLeft: 16,
  },
  indent3: {
    marginLeft: 24,
    paddingVertical: 10,
  },
  section: {
    margin: '10px 0',
    textDecoration: 'underline',
  },
  parg: {
    margin: '8px 0',
  },
  buttons: {
    backgroundColor: 'white',
    padding: '16px',
    display: 'flex',
  },
  formField: {
    marginLeft: 'auto',
  },
  button: {
    margin: '8px',
  },
}

// Type
type Props = {
  actions: {
    postEulaStatus: Function,
    logout: Function,
  },
}

export class Eula extends Component {
  props: Props
  onAccept: Function
  onReject: Function

  constructor (props: Props) {
    super(props)

    this.onAccept = this.onAccept.bind(this)
    this.onReject = this.onReject.bind(this)
  }

  onAccept () {
    this.props.actions.postEulaStatus()
  }

  onReject () {
    this.props.actions.logout()
  }

  render () {
    return (
      <div>
        <div style={styles.text}>
          <p style={styles.heading}>TERMS AND CONDITIONS</p>
          <section style={styles.section}>A. PORTAL END USER LICENCE AGREEMENT</section>
          <p style={{...styles.bold, ...styles.parg}}>
            PLEASE READ THE FOLLOWING AGREEMENT CAREFULLY! IT CONTAINS VERY IMPORTANT INFORMATION ABOUT YOUR RIGHTS AND
            OBLIGATIONS, AS WELL AS LIMITATIONS AND EXCLUSIONS THAT MAY APPLY TO YOU. THIS DOCUMENT CONTAINS A DISPUTE
            RESOLUTION CLAUSE. BY CLICKING ON THE “I ACCEPT” BUTTON OR LINK, YOU ARE CONSENTING TO BE BOUND BY AND ARE
            BECOMING A PARTY TO THIS AGREEMENT. IF YOU DO NOT AGREE TO ALL OF THE TERMS AND CONDITIONS OF
            THIS AGREEMENT, CLICK THE “I DO NOT ACCEPT” BUTTON OR LINK OR EXIT THE SOFTWARE.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            BY CLICKING “I ACCEPT,” YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS
            AGREEMENT, AND ANY ADDITIONAL TERMS AND CONDITIONS OR FUTURE MODIFICATIONS.
          </p>
          <p style={styles.parg}>
            NOW THEREFORE in consideration of the foregoing and the mutual promises, covenants and agreements herein
            contained, and for other good and valuable consideration, the receipt and sufficiency of which the parties
            hereby acknowledge, the parties agree as follows:
          </p>
          <p style={styles.bold}>1. DEFINITIONS</p>
          <p style={styles.indent1}>
            1.1 <span style={styles.bold}>Definitions.</span> The following terms, wherever used in this Agreement,
            shall have the respective meanings set forth below:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              “Agreement” means this End User Licence Agreement and all of the schedules and appendices attached hereto,
               and any additional terms, conditions or future modifications as described herein.
            </li>
            <li>
              “Canada's Anti-Spam Legislation” means an Act to promote the efficiency and adaptability of the Canadian
               economy by regulating certain activities that discourage reliance on electronic means of carrying out
               commercial activities, and to amend the Canadian Radio-television and Telecommunications Commission Act,
               the Competition Act, the Personal Information Protection and Electronic Documents Act and the
               Telecommunications Act, as amended.
            </li>
            <li>
              “Confidential Information” means any and all information, whether disclosed in writing, electronically,
               orally, in machine readable form or otherwise, of any nature and in any form, and whether or not
               specifically marked as confidential, including but not limited to, the terms and agreements contained
               in this Agreement, the information gathered by inspection or heard by the Licensee from an inspection
               of any property, activities or facilities of FARMERS EDGE, the Software, the Results, business plans,
               business strategies, research and development plans, marketing plans, pricing information and any other
               technical, engineering, manufacturing, product, servicing, personnel, business or financial information,
               which is provided, developed, made available or disclosed by FARMERS EDGE to the Licensee, or that the
               Licensee prepares that contain or otherwise reflect a review of any of the information referred to in
               this Section.
            </li>
            <li>
              “Content Licence” has the meaning assigned to it in Section 4.2(b).
            </li>
            <li>
              “Defaulting Party” has the meaning assigned to it in Section 10.2(c).
            </li>
            <li>
              “Disagreement” has the meaning assigned to it in Section 11.2.
            </li>
            <li>
              “FARMERS EDGE” means Farmers Edge Inc., a corporation incorporated under the laws of the Province of
               Manitoba, and includes all of FARMERS EDGE’s affiliates, subsidiaries, shareholders, officers,
               directors, agents, representatives, contractors, suppliers, customers, licensors, licensees,
               partners, employees, successors and assigns, except for the Licensee.
            </li>
            <li>
              “Intellectual Property” means any and all rights in and in relation to any intellectual and industrial
               property of every nature, under the laws of any country, whether registered or unregistered, including
               without limitation, improvements, modifications, developments, trade secrets, proprietary information,
               know-how, derivative works, copyrights, moral rights, databases, data structures, database designs,
               screenshots, database indices, modules, objects, classes, packages, in-line comments, user interfaces,
               design documents, test plans and scripts, computer programs, applications and software (whether in
               source, object code or executable formats) and related documentation and manuals, literary and/or
               artistic works, compositions, compilations, diagrams, designs, domain names, patents (including without
               limitation, divisions, reissues, substitutions, prolongations, continuations, re-examinations,
               continuations in part, renewals, modifications and extensions thereof), trademarks, trade dress,
               rights under registered user agreements, trade names, corporate names, business names, social
               media handles, hashtags, keywords and other trademark and service mark rights and goodwill,
               industrial designs, models and utility models, prototypes, inventions, ideas, data, suggestions,
               conceptions, formulations, compounds, methods, discoveries, processes, compositions, research data
               and results, project plans, notes, testing materials, logs,  drawings, information, findings, results,
               technologies, materials, formulae, specifications and architecture, data, techniques, instructions,
               manuals, records, look and feel, integrated circuit topography, studies, blueprints, packaging, reports,
               files, samples, photographs, graphs, graphics, text files, websites (including all of the related web
               pages, content, software, information, photographs, images, illustrations, audio clips, video clips,
               data, code, graphics, text files, icons, titles, objects, concepts, artwork, animations, text,
               sounds, audio-visual effects, methods of operation and the look and feel of the content and
               information), drawings, interfaces, screen display, audio visual display or presentation, algorithms,
               documentation and media, and procedures, in whatever form or medium, including:
            </li>
            <ol type='i' style={styles.indent3}>
              <li>
                the benefit of all registrations and applications to register as well as all rights to apply for
                registration of any of the foregoing items and all rights in the nature of any of the foregoing items,
                each for their full term (including any extensions or renewals thereof);
              </li>
              <li>
                any other statutory protection of whatever kind;
              </li>
              <li>
                all such other rights which may be recognized under law, equity, contract or otherwise, to protect
                technical or other creative contributions or expressions;
              </li>
              <li>
                confidential information, know-how and trade secrets;
              </li>
              <li>
                all priority rights derived from any of the foregoing items and all rights in the nature of any of the
                 foregoing items for any and all countries in the world; and
              </li>
              <li>
                all rights to sue for infringement, misappropriation and/or violation of any of the foregoing items and
                all rights in the nature of any of the foregoing items, whether arising prior to or subsequent to the
                date of this Agreement.
              </li>
            </ol>
            <li>
              “Licence” has the meaning assigned to it in Section 4.2(a).
            </li>
            <li>
              “Licensee” means a person who uses and accesses the Software and/or the Results in any manner.
              Such a person is also referred to in this Agreement as “you”.
            </li>
            <li>
              “Licensee Content” means any data and information distributed or submitted electronically or otherwise
              by you via the Software, including but not limited to, data, soil information, agricultural data,
              inventory information and shipping information.
            </li>
            <li>
              “Non-Defaulting Party” has the meaning assigned to it in Section 10.2(c).
            </li>
            <li>
              “Requirements” has the meaning assigned to it in Section 7.3.
            </li>
            <li>
              “Results” means any and all results, reports and recommendations based on the Licensee Content,
              user data, analytics and/or user data results that FARMERS EDGE provides to the Licensee, including
              ratios, soil samples, nutrient prescriptions, controller files, field boundary delineations,
              shipping logistics, soil results, grid setups, lab results indicators and soil performance of a farm.
              The term “Results” shall also include any modification or enhancement to the Licensee Content and any
              Intellectual Property relating thereto by FARMERS EDGE, and any Intellectual Property made, conceived,
              acquired, suggested, discovered or developed by FARMERS EDGE, or under FARMERS’ EDGE direction, either
              solely or jointly with others, which relates to, relies on or uses the Licensee Content and all
              Intellectual Property relating thereto.
            </li>
            <li>
              “Software” means the AgPhD Soils nutrient management portal and software, together with (a) all computer
              programs, software, website, database and/or multi-media content in object code form that are embedded
              in the said portal and software or delivered to the Licensee separately by FARMERS EDGE and are designed
              to be used in conjunction with the said portal and software; and (b) all documentation relating to the
              said portal and software, including without limitation, manuals, handbooks and any user guides and/or
              other instructions concerning the access, use and/or operation of the Software.
            </li>
            <li>
              “Subscribing Organization” has the meaning assigned to it in Section 2.1.
            </li>
            <li>
              “Subscription Fee” has the meaning assigned to it in Section 3.1.
            </li>
            <li>
              “Term” has the meaning assigned to it in Section 10.1.
            </li>
            <li>
              “Territory” means North America.
            </li>
          </ol>
          <p style={styles.bold}>
            2. SUBSCRIBING ORGANIZATION
          </p>
          <p style={styles.indent1}>
            2.1 <span style={styles.bold}>Subscribing Organization. </span>
            If you are registering or using the Software or the Results on behalf of, or in connection with, your
            employment or engagement with a company, entity or organization (collectively, the “Subscribing
            Organization”), you represent and warrant that you are an authorized representative of that Subscribing
            Organization with the authority to bind such Subscribing Organization to the terms and conditions of this
            Agreement, and you hereby do agree to be bound by the terms and conditions of this Agreement on behalf of
            such Subscribing Organization. In such a case, references to “you” and/or the “Licensee” in this Agreement
            shall be construed to mean you, the Subscribing Organization, and any other individual that uses the
            Software or the Results on the Subscribing Organization’s behalf or in connection with their employment
            with or engagement by such Subscribing Organization. To the extent your Subscribing Organization has a
            separate transaction agreement with FARMERS EDGE, that agreement will define the order of precedence
            between the terms of this Agreement and that separate transaction agreement with respect to such
            Subscribing Organization, provided that you remain individually bound by the terms and conditions of this
            Agreement with respect to your use of the Software and the Results.
          </p>
          <p style={styles.bold}>
            3. FEES
          </p>
          <p style={styles.indent1}>
            3.1 <span style={styles.bold}>
              FARMERS EDGE shall charge the Licensee and the Licensee shall pay to FARMERS EDGE a subscription fee
              described on www.agphdsoils.com or in any transaction agreement between you and FARMERS EDGE
              (the “Subscription Fee”). The Subscription Fee shall be paid in accordance with this Agreement or any
              transaction agreement between you and FARMERS EDGE, plus any applicable taxes (including any goods and
              services taxes), during the Term.  FARMERS EDGE reserves the right to change at any time the Subscription
              Fee without any notice or liability to you or any other person. Any amounts remaining unpaid after the due
              date shall have interest charged thereon at a rate of 1.5% per month. If and when applicable, the Licensee
              shall pay all taxes and any related interest or penalty howsoever designated and imposed as a result of
              the existence or operation of this Agreement, the Results or the Software, except for taxes on the income
              or profits of FARMERS EDGE.
            </span>
          </p>
          <p style={styles.bold}>
            4. LICENCES
          </p>
          <p style={styles.indent1}>
            4.1 <span style={styles.bold}>Delivery. </span>
            Subject to the terms and conditions of this Agreement:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              FARMERS EDGE will host the Software on its servers for access and reasonable use by the Licensee; and
            </li>
            <li>
              FARMERS EDGE shall, from time to time and at its sole discretion, provide the Results to the Licensee.
            </li>
          </ol>
          <p style={styles.indent1}>
            4.2 <span style={styles.bold}>Licences. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              Subject to the terms and conditions of this Agreement, FARMERS EDGE hereby grants to the Licensee a
              personal, revocable, non-exclusive, non-assignable, non-transferable, non-sublicenceable right and licence
              to access and use the Software and the Results in the Territory for the Term in accordance with this
              Agreement (collectively, the “Licence”). For clarity, the Licence is personal to the Licensee, and
              the Licence may not be assigned, transferred or sublicensed to any other person or accessed and used for
              purposes other than as described in this Agreement. Using the Software and the Results for any other
              purpose or in any other manner is strictly prohibited. FARMERS EDGE retains all rights not expressly
              granted hereunder.  Any access and use of the Software and the Results, other than as specifically
              authorized under this Agreement, including sublicensing to any person, without the prior written consent
              of FARMERS EDGE, is strictly prohibited and may, at the discretion of FARMERS EDGE, terminate the Licence.
            </li>
            <li>
              Subject to the terms and conditions of this Agreement, the Licensee hereby grants to FARMERS EDGE a
              royalty-free, fully-paid, perpetual, irrevocable, transferable, sublicenceable, worldwide and
              non-exclusive right and licence to access, reproduce, copy, distribute, create derivative works of,
              adapt, translate, transmit, arrange, modify, host, bundle, use and fully exploit the Licensee Content
              and any Intellectual Property relating thereto (the “Content Licence”). FARMERS EDGE can grant
              sublicences with respect to the Content Licence.
            </li>
          </ol>
          <p style={styles.indent1}>
            4.3 <span style={styles.bold}>Restrictions. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee agrees and covenants (i) to keep all disclaimers and copyright, trademark and other
              proprietary notices intact on the Software and the Results; (ii) that access and use of the Software
              and/or the Results does not transfer to the Licensee any ownership or other rights in the Software or
              the Results; and (iii) to access and use the Software and the Results only in the manner described
              expressly in this Agreement and subject to all applicable laws.
            </li>
            <li>
              The Licensee may not use, modify, enhance, translate, transfer, transmit, disclose, copy, release,
              communicate, reproduce, provide or make available to any third party, in any way, the Confidential
              Information, the Results and/or the Software, and all Intellectual Property relating thereto, in whole
              or in part, except as expressly provided for in this Agreement.  The Licensee shall not copy, use,
              analyze, translate, convert, reverse engineer, decompile, disassemble or otherwise reduce the Software,
              the Results and/or the Confidential Information, and all Intellectual Property relating thereto,
              to a human readable form, nor shall the Licensee permit any operator, employee, agent, outside consultant
              or other third party to do any of the foregoing. Any modification or enhancement to the Software,
              the Results and/or the Confidential Information, and any Intellectual Property relating thereto, other
              than as specifically authorized under this Agreement, without the prior written consent of FARMERS EDGE,
              is strictly prohibited and may, at the discretion of FARMERS EDGE, terminate the Licence and any
              Intellectual Property made, conceived, acquired, suggested, discovered or developed by the Licensee,
              or under the Licensee’s direction, either solely or jointly with others, which relates to, relies
              on or uses the Software, the Results and/or the Confidential Information, and all Intellectual Property
              relating thereto, shall be treated as Confidential Information of FARMERS EDGE and shall be the sole
              exclusive property of FARMERS EDGE. The Licensee agrees and covenants to disclose promptly in writing
              to FARMERS EDGE any such Intellectual Property.
            </li>
            <li>
              The Licensee shall not sell, market, rent, lease, transfer, distribute, sublicense or create derivative
              works of the Software, the Results and/or the Confidential Information, and all Intellectual Property
              relating thereto, in whole or in part, to any third party.
            </li>
            <li>
              This Agreement shall not be construed as granting or conferring any ownership, security right, title,
              rights or licences to use or modify in any manner the Software, the Results and/or the Confidential
              Information, and all Intellectual Property relating thereto, except for the Licence.
            </li>
            <li>
              The Licensee agrees and covenants not to assign or grant a sublicence for this Agreement or any rights
              or licences obtained pursuant to it.  The Licensee has no right to grant sublicences.
            </li>
          </ol>
          <p style={styles.bold}>
            5. ACKNOWLEDGEMENTS & COVENANTS
          </p>
          <p style={styles.indent1}>
            5.1 <span style={styles.bold}>Acknowledgements. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee agrees and acknowledges the validity of the Software and the Results. The Licensee shall
              not use or modify the Software or the Results in any manner likely to negate, impair or dilute any of the
              rights of FARMERS EDGE. The Licensee shall not, either during the Term or at any time thereafter,
              contest or dispute or assist another in contesting or disputing, directly or indirectly, the validity,
              ownership, control or enforceability of any of FARMERS EDGE’s right, title and interest in and to the
              Software, the Results and/or the Confidential Information, and all Intellectual Property relating thereto.
            </li>
            <li>
              The Licensee agrees that it shall not at any time file any Intellectual Property, secure and/or register
              any Intellectual Property or maintain any Intellectual Property relating to or arising out of the
              Software, the Results and/or the Confidential Information, or any Intellectual Property relating thereto.
            </li>
            <li>
              The Licensee shall not, to the extent legally enforceable, file any action to challenge or raise any
              question or objection, or cause to be filed any such action or cause to be raised any such question
              or objection, to the validity, enforceability, registration or patentability of the Software, the
              Results and/or the Confidential Information, or any Intellectual Property relating thereto, on any
              grounds whatsoever.
            </li>
            <li>
              The Licensee shall provide to FARMERS EDGE all such access, assistance and co-operation as is reasonably
              requested by FARMERS EDGE in order to facilitate the performance by FARMERS EDGE of its obligations
              hereunder.
            </li>
            <li>
              The Licensee shall access and use the Software and the Results in a careful and prudent manner in
              accordance with this Agreement.
            </li>
            <li>
              The Licensee shall (a) comply with all laws and directions of FARMERS EDGE regarding the access and use
              of the Software and the Results; (b) not, nor shall the Licensee permit any person, other than
              FARMERS EDGE’s authorized representatives, to modify, disassemble, perform maintenance on, service
              or attempt any repair or adjustment to the Software.
            </li>
            <li>
              The Licensee agrees to assume the full risk for loss or damage to the Software and/or the Results,
              however caused, except if caused by the negligent act or omission of FARMERS EDGE.
            </li>
            <li>
              The Licensee shall keep the Software, the Results and the Confidential Information free and clear of
              any liens or other encumbrances.
            </li>
          </ol>
          <p style={styles.indent1}>
            5.2 <span style={styles.bold}>Service Level. </span>
            You shall ensure that your systems include reasonable attacker defences and security measures.
            Your systems shall be configured with reasonable security measures related to data theft
            (through SSL encryption) and unauthorized network access from other unlicensed computers within
            your end users.
          </p>
          <p style={styles.indent1}>
            5.3 <span style={styles.bold}>Licensee Costs. </span>
            The Licensee shall be solely responsible for:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              the cost of all necessary servicing, repair or correction of problems caused by viruses or other harmful
              components, unless such viruses or other harmful components are the direct result of FARMERS EDGE’s
              negligence or wilful conduct; and
            </li>
            <li>
              the cost of acquiring, installing, operating, servicing, maintaining and updating all equipment,
              computers, software and communication services not owned or operated by or on behalf of FARMERS EDGE
              that allows the Licensee to access and use the Software and the Results.
            </li>
          </ol>
          <p style={styles.indent1}>
            5.4 <span style={styles.bold}>Availability. </span>
            The Licensee acknowledges and agrees that the operation and availability of the systems used for accessing,
            using and interacting with the Software, the Results and/or the Licensee Content, including the public
            telephone, computer networks and the Internet, or to transmit information whether or not supplied by
            you or FARMERS EDGE, can be unpredictable and may, from time to time, interfere with or prevent the
            access, the use and/or the operation of the Software, the Results and/or the Licensee Content. The
            Licensee acknowledges and agrees that the bandwidth and servers provided by FARMERS EDGE are not
            guaranteed and the Licensee agrees not to use an unreasonable amount of bandwidth or unreasonably
            burden FARMERS EDGE’s servers. FARMERS EDGE is not responsible for any outages at the your premises,
            including internal network, local infrastructure or facilities, unless directly attributable to
            FARMERS EDGE’s negligence or wilful conduct. In the event viruses are detected in your local
            client environment managed by FARMERS EDGE, FARMERS EDGE may be required to secure the systems
            by denying access to infected users. If the virus infection is traced back to you, you will be
            invoiced for remedying the virus. The Licensee acknowledges and agrees that the Results may
            not be available at all times and may contain inaccuracies.
          </p>
          <p style={styles.indent1}>
            5.5 <span style={styles.bold}>Licensee Content. </span>
            The Licensee acknowledges and agrees that FARMERS EDGE has the perpetual and irrevocable right to delete
            any or all of the Licensee Content and the Results, including any Intellectual Property relating thereto,
            from FARMERS EDGE’s servers and from the Software, whether intentionally or unintentionally, and for any
            reason or no reason, without any liability of any kind to the Licensee or any other party. THE LICENSEE
            UNDERSTANDS AND AGREES THAT FARMERS EDGE HAS THE RIGHT, BUT NOT THE OBLIGATION, TO REMOVE, IN WHOLE OR
            IN PART, ANY LICENSEE CONTENT, RESULTS OR OTHER CONTENT RELATED TO THE SOFTWARE, INCLUDING WITHOUT
            LIMITATION, DATA, ACCOUNT HISTORY AND ACCOUNT CONTENT RESIDING ON FARMERS EDGE’S SERVERS OR SOFTWARE,
            AT ANY TIME FOR ANY REASON OR NO REASON, WITH OR WITHOUT NOTICE AND WITH NO LIABILITY OF ANY KIND.
          </p>
          <p style={styles.indent1}>
            5.6 <span style={styles.bold}>Representations & Warranties. </span>
            When the Licensee distributes or submits the Licensee Content on or through the Software, the Licensee
            represents and warrants: (1) that the Licensee owns or otherwise controls all of the rights, including
            moral rights and Intellectual Property rights, to the Licensee Content; (2) that the Licensee can grant
            or has obtained all rights and consents that are necessary for the Licensee to grant any rights and
            licences described in this Agreement and relating to the Licensee Content to FARMERS EDGE, including
            the Content Licence; (3) that the Licensee Content is accurate and is original to the Licensee and that
            no other party has any rights thereto; (4) that any and all access, use, submission, modification,
            transmission, creation of derivative works, adaptation, translation, hosting, bundling, arrangement,
            distribution and full exploitation of the Licensee Content will not infringe the rights of any
            third party and will not otherwise cause injury to any person or entity; and (5) that the Licensee
            will immediately notify FARMERS EDGE of any Licensee Content that does not comply with this Agreement
            or may infringe the rights of a third party or third parties.</p>
          <p style={styles.bold}>
            6. INTELLECTUAL PROPERTY
          </p>
          <p style={styles.indent1}>
            6.1 <span style={styles.bold}>Ownership. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              FARMERS EDGE is the sole and exclusive owner of and shall own all right, title and interest in the
              Software, the Results and the Confidential Information, and all Intellectual Property relating thereto.
              The Licensee shall maintain the Software, the Results and the Confidential Information, and all
              Intellectual Property relating thereto, in confidence, except as otherwise stated in this Agreement.
              The Software and the Results, and all Intellectual Property relating thereto, shall be treated as
              the Confidential Information of FARMERS EDGE.
            </li>
            <li>
              The Licensee is the sole and exclusive owner of and shall own all right, title and interest in the
              Licensee Content.
            </li>
          </ol>
          <p style={styles.indent1}>
            6.2 <span style={styles.bold}>Assignment of IP. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee assigns and transfers and/or shall cause the assignment and transfer over to FARMERS EDGE
              of any right, title and interest, worldwide, it may have or may in the future acquire in and to the
              Software, the Results and the Confidential Information, and all Intellectual Property relating thereto,
              without any remuneration. The Licensee agrees, at the request of FARMERS EDGE, to do or to cause all
              lawful acts to secure and protect FARMERS EDGE’s rights and interests in the Software, the Results and
              the Confidential Information, and all Intellectual Property relating thereto, without any compensation,
              and the Licensee agrees, when requested by FARMERS EDGE, to execute, acknowledge and deliver to
              FARMERS EDGE, without compensation, any and all instruments, assignments, waivers and documents
              relating thereto.
            </li>
            <li>
              FARMERS EDGE assigns and transfers and/or shall cause the assignment and transfer over to the Licensee
              of any right, title and interest, worldwide, it may have or may in the future acquire in and to the
              Licensee Content, without any remuneration.
            </li>
          </ol>
          <p>
            6.3 <span style={{...styles.bold, ...styles.indent1}}>Waiver. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee waives any rights which the Licensee may have in the Software, the Results and the
              Confidential Information, and all Intellectual Property relating thereto, including moral rights
              in the Software, the Results and the Confidential Information, and all Intellectual Property
              relating thereto.
            </li>
            <li>
              FARMERS EDGE waives any rights which FARMERS EDGE may have in the Licensee Content, including moral
              rights in the Licensee Content.
            </li>
          </ol>
          <p>
            6.4 <span style={{...styles.bold, ...styles.indent1}}>IP Notices. </span>
            The Licensee shall mark in the appropriate place on or within each of the items which bear the Software
            and/or the Results, an appropriate notice of copyright, trademark or otherwise as stipulated by FARMERS
            EDGE from time to time, and a notice that the Licensee is using the same as a “Licensee” or other such
            designation, as required from time to time by FARMERS EDGE.  The Licensee shall ensure that all proprietary
            notices, trademark notices, copyright notices and disclaimers of FARMERS EDGE, its suppliers or its
            licensors, as the case may be, on the Software and the Results, as provided to the Licensee by
            FARMERS EDGE, are in place and left intact at all times, and are placed in such location or
            locations as FARMERS EDGE may reasonably advise.
          </p>
          <p style={styles.bold}>
            7. CONFIDENTIALITY
          </p>
          <p style={styles.indent1}>
            7.1 <span style={styles.bold}>Confidentiality. </span>
            The parties acknowledge that it shall be necessary for FARMERS EDGE to disclose or make available to
            the Licensee the Confidential Information. The Confidential Information shall remain the sole exclusive
            property of FARMERS EDGE. Both during and after the termination or expiration of this Agreement,
            the Licensee:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              covenants to keep the Confidential Information strictly confidential;
            </li>
            <li>
              shall make no further use of the Confidential Information upon the return or the destruction of the
              Confidential Information;
            </li>
            <li>
              shall not nor will it assist any other person, directly or indirectly, at any time, to (1) use for itself
              or others, or divulge to others, the Confidential Information; nor (2) use, publish or sell for its own
              purposes or for any purpose, other than to carry out its obligations under this Agreement, the
              Confidential Information;
            </li>
            <li>
              shall take all steps and do all things necessary to preserve the value, confidential nature and
              proprietary nature of the Confidential Information;
            </li>
            <li>
              shall immediately notify FARMERS EDGE of any use, disclosure, transfer or transmission of the Confidential
              Information or any part thereof which is not in accordance with the terms of this Agreement;</li>
            <li>
              may make the Confidential Information available to its agents, contractors or employees having a need
              to know such information solely for the purposes described in this Agreement and only to the extent
              necessary for such agents, contractors or employees. Prior to making any such disclosure, the Licensee
              shall provide to FARMERS EDGE a listing of all persons receiving the Confidential Information and shall
              cause all such agents, contractors or employees to execute non-disclosure agreements or other agreements
              containing substantially similar terms and conditions to those contained in this Agreement;
            </li>
            <li>
              acknowledges and agrees that, save and except for the purpose of discharging its obligations pursuant
              to this Agreement and save and except as provided for in this Agreement, it has no right whatsoever to
              any of the Confidential Information; and
            </li>
            <li>
              shall take all reasonable steps to prevent the accidental or intentional disclosure of the Confidential
              Information to third parties and shall comply with any reasonable request of FARMERS EDGE with regard
              to the safeguarding of the Confidential Information.
            </li>
          </ol>
          <p style={styles.indent1}>
            7.2 <span style={styles.bold}>Exclusions. </span>
            Information shall not be considered to be Confidential Information if it:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              becomes publicly available through no fault of the recipient;
            </li>
            <li>
              at the time communicated by the disclosing party as Confidential Information, was already in the
              possession of the recipient;
            </li>
            <li>
              is lawfully received from a third party having the right to disclose the Confidential Information without
              restriction; or
            </li>
            <li>
              has been independently developed without access to or use of any Confidential Information.
            </li>
          </ol>
          <p style={styles.indent1}>
            7.3 <span style={styles.bold}>Requirements. </span>
            If the Licensee becomes compelled to disclose any Confidential Information pursuant to law, regulation or
            a lawful order or process (collectively, the “Requirements”), the Licensee shall provide FARMERS EDGE
            with prompt notice of any such Requirement and shall cooperate with FARMERS EDGE in seeking to obtain any
            protective order or other arrangement pursuant to which the Confidential Information is preserved. If
            such an order or arrangement is not obtained, the Licensee shall disclose only that portion of the
            Confidential Information as is required pursuant to such Requirement. Any such required disclosure shall
            not, in and of itself, change the status of the disclosed information as Confidential Information under the
            terms of this Agreement.
          </p>
          <p style={styles.bold}>
            8. INFRINGEMENT
          </p>
          <p style={styles.indent1}>
            8.1 <span style={styles.bold}>Infringement. </span>
            The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee and FARMERS EDGE shall promptly notify each other in writing of any conflicting use,
              act of infringement or appropriation that comes to their attention regarding the Software, the Results,
              the Confidential Information and/or the Licensee Content, and all Intellectual Property relating thereto,
              and shall provide any evidence relating to same which is reasonably available.
            </li>
            <li>
              In such cases where it is alleged that a third party is infringing the Intellectual Property rights of
              FARMERS EDGE,  FARMERS EDGE shall have the sole right, but not the obligation, at FARMERS EDGE’s sole
              cost and expense, (i) to bring an action for infringement against the alleged infringer or to take steps
              as it may deem necessary in order to terminate such conflict, infringement or appropriation; or (ii)
              to investigate, defend, litigate and settle any such complaint.  FARMERS EDGE may in its sole discretion
              settle any action or complaint as it sees fit.  Any damages or sums recovered by FARMERS EDGE in such
              action or complaint or any settlement thereof shall be retained by FARMERS EDGE. The Licensee shall not
              at any time settle any such action or complaint without first obtaining the written consent of
              FARMERS EDGE.
            </li>
            <li>
              The Licensee shall cooperate fully with and assist FARMERS EDGE to the fullest extent possible on any
              such action or step and in the event of any such complaint and execute such documents and do such
              other acts and things as in the opinion of FARMERS EDGE may be necessary, including to testify
              when requested by FARMERS EDGE, and to make available any records, papers, information, specimens,
              and the like.
            </li>
          </ol>
          <p style={styles.bold}>
            9. LIMITATIONS AND DISCLAIMERS
          </p>
          <p style={styles.indent1}>
            9.1 <span style={styles.bold}>Disclaimers & Limitation of Liability. The parties agree that:.</span>
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2, ...styles.bold}}>
            <li>
              THE LAWS OF CERTAIN JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR CONDITIONS OR THE
              EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO THE LICENSEE, SOME OR ALL OF THE BELOW
              DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MIGHT NOT APPLY TO THE LICENSEE, AND THE LICENSEE MIGHT HAVE
              ADDITIONAL RIGHTS.
            </li>
            <li>
              THE LICENSEE AGREES THAT THE SOFTWARE, THE RESULTS AND THE CONFIDENTIAL INFORMATION, AND ALL INTELLECTUAL
              PROPERTY RELATING THERETO, ARE PROVIDED BY FARMERS EDGE ON AN "AS IS" AND "AS AVAILABLE" BASIS. THE
              LICENSEE FURTHER AGREES THAT THE LICENSEE’S ACCESS AND USE OF THE SOFTWARE, THE RESULTS AND THE
              CONFIDENTIAL INFORMATION, AND ALL INTELLECTUAL PROPERTY RELATING THERETO, SHALL BE AT THE LICENSEE’S
              SOLE RISK.
            </li>
            <li>
              TO THE FULLEST EXTENT PERMITTED BY LAW, FARMERS EDGE DISCLAIMS ALL WARRANTIES, CONDITIONS, GUARANTEES
              AND/OR REPRESENTATIONS, EXPRESS, STATUTORY IMPLIED OR ARISING BY CUSTOM, COURSE OF DEALING OR TRADE USAGE,
              IN CONNECTION WITH THE SOFTWARE, THE RESULTS, THE LICENSEE CONTENT AND THE CONFIDENTIAL INFORMATION, AND
              ALL INTELLECTUAL PROPERTY RELATING THERETO, AND THE LICENSEE’S ACCESS TO AND USE THEREOF, INCLUDING
              WITHOUT LIMITATION, ANY IMPLIED WARRANTY, CONDITION, GUARANTEE AND/OR REPRESENTATION OF MERCHANTABILITY
              AND FITNESS FOR A PARTICULAR PURPOSE, TITLE, PERFORMANCE, QUALITY, NON-INFRINGEMENT, SECURITY, ACCURACY,
              COMPLETENESS, SUITABILITY OR ANY IMPLIED WARRANTY, CONDITION, GUARANTEE OR REPRESENTATION ARISING FROM
              COURSE OF DEALING OR USAGE OF TRADE.
            </li>
            <li>
              FARMERS EDGE MAKES NO WARRANTIES, CONDITIONS, GUARANTEES OR REPRESENTATIONS ABOUT THE TRUTHFULNESS,
              USEFULNESS, ACCURACY OR COMPLETENESS OF THE SOFTWARE, THE RESULTS,  THE LICENSEE CONTENT AND CONFIDENTIAL
              INFORMATION, AND INCLUDING ALL INTELLECTUAL PROPERTY RELATING THERETO, OR THE AVAILABILITY, QUALITY,
              CHARACTERISTICS, LEGITIMACY, FUNCTIONALITY, SECURITY OR SAFETY OF ANY OF THE SOFTWARE, THE RESULTS,
              THE LICENSEE CONTENT AND CONFIDENTIAL INFORMATION, AND INCLUDING ALL INTELLECTUAL PROPERTY RELATING
              THERETO, AND FARMERS EDGE ASSUMES NO LIABILITY OR RESPONSIBILITY THEREOF.
            </li>
            <li>
              FARMERS EDGE ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (A) PERSONAL INJURY OR PROPERTY DAMAGE, OF
              ANY NATURE WHATSOEVER, RESULTING FROM THE LICENSEE’S ACCESS TO AND USE OF THE SOFTWARE, THE RESULTS
              AND/OR CONFIDENTIAL INFORMATION, AND INCLUDING ALL INTELLECTUAL PROPERTY RELATING THERETO; (B) ANY
              UNAUTHORIZED ACCESS TO AND USE OF FARMERS EDGE’S SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
              AND/OR FINANCIAL INFORMATION STORED THEREIN; (C) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
              FROM THE SOFTWARE OR THE RESULTS; (D) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE, WHICH MAY BE
              TRANSMITTED TO OR THROUGH THE SOFTWARE AND/OR THE RESULTS BY ANY THIRD PARTY; AND/OR (E) ANY ERRORS
              OR OMISSIONS CONTAINED IN THE SOFTWARE, THE RESULTS, THE LICENSEE CONTENT AND/OR CONFIDENTIAL
              INFORMATION, AND INCLUDING ALL INTELLECTUAL PROPERTY RELATING THERETO, AND/OR FOR ANY LOSS OR
              DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE ACCESS TO OR USE OF THE SOFTWARE, THE RESULTS, THE
              LICENSEE CONTENT AND/OR CONFIDENTIAL INFORMATION, AND ALL INTELLECTUAL PROPERTY RELATING THERETO.
            </li>
            <li>
              IN NO EVENT SHALL FARMERS EDGE BE LIABLE TO THE LICENSEE OR ANY OTHER PERSON FOR ANY INDIRECT,
              INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY LOSS OR DAMAGE ARISING FROM, CONNECTED WITH,
              OR RELATING TO (I) THE SOFTWARE, THE RESULTS, THE LICENSEE CONTENT AND/OR CONFIDENTIAL INFORMATION,
              AND INCLUDING ALL INTELLECTUAL PROPERTY RELATING THERETO, AND (2) THIS AGREEMENT, INCLUDING BUT NOT
              LIMITED TO, LOSS OF DATA, BUSINESS, BUSINESS INTERRUPTION, MARKETS, SAVINGS, INCOME, PROFITS, USE,
              PRODUCTION, REPUTATION AND/OR GOODWILL, ANTICIPATED OR OTHERWISE, AND/OR ECONOMIC LOSS, UNDER ANY
              THEORY OF LIABILITY (WHETHER IN CONTRACT, TORT, STRICT LIABILITY OR ANY OTHER THEORY OR LAW OR EQUITY),
              REGARDLESS OF ANY NEGLIGENCE OR OTHER FAULT OR WRONGDOING (INCLUDING WITHOUT LIMITATION GROSS NEGLIGENCE
              AND FUNDAMENTAL BREACH) BY FARMERS EDGE OR ANY PERSON FOR WHOM FARMERS EDGE IS RESPONSIBLE, AND EVEN
              IF FARMERS EDGE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE BEING INCURRED.  IN THOSE
              JURISDICTIONS THAT DO NOT ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
              INCIDENTAL DAMAGES, IN SUCH JURISDICTIONS, THE LIABILITY OF FARMERS EDGE SHALL BE LIMITED TO THE FULL
              EXTENT PERMITTED BY LAW.
            </li>
            <li>
              THE LICENSEE HAS SOLE RESPONSIBILITY FOR ANY DECISIONS THE LICENSEE MAKES BASED ON INFORMATION CONTAINED
              IN THE SOFTWARE, THE RESULTS, THE LICENSEE CONTENT AND/OR THE CONFIDENTIAL INFORMATION, AND INCLUDING ALL
              INTELLECTUAL PROPERTY RELATING THERETO.
            </li>
            <li>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE LICENSEE ACKNOWLEDGES AND AGREES THAT ITS SOLE AND
              EXCLUSIVE REMEDY FOR ANY DISPUTE WITH FARMERS EDGE IS TO STOP USING THE SOFTWARE AND THE RESULTS.
            </li>
            <li>
              FARMERS EDGE WILL NOT BE RESPONSIBLE FOR ANY DAMAGES THE LICENSEE OR ANY THIRD PARTY MAY SUFFER AS A
              RESULT OF THE TRANSMISSION, STORAGE OR RECEIPT OF THE RESULTS AND  CONFIDENTIAL OR PROPRIETARY
              INFORMATION THAT THE LICENSEE MAKES OR THAT THE LICENSEE EXPRESSLY OR IMPLICITLY AUTHORIZES FARMERS
              EDGE TO MAKE, OR FOR ANY ERRORS OR ANY CHANGES MADE TO ANY TRANSMITTED, STORED OR RECEIVED INFORMATION
              OR RESULTS.
            </li>
            <li>
              FARMERS EDGE’S TOTAL AGGREGATE LIABILITY TO THE LICENSEE OR ANY THIRD PARTIES IN ANY CIRCUMSTANCE IS
              LIMITED TO THE GREATER OF (A) THE AMOUNT OF FEES THE LICENSEE PAID TO FARMERS EDGE; AND (B) $100.
              SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES,
              SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO THE LICENSEE.
            </li>
            <li>
              IN ADDITION, NO ADVICE OR INFORMATION (ORAL OR WRITTEN) OBTAINED BY THE LICENSEE FROM FARMERS EDGE SHALL
              CREATE ANY WARRANTY.
            </li>
            <li>
              THE LICENSEE AND FARMERS EDGE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SOFTWARE,
              THE RESULTS, THE LICENSEE CONTENT AND/OR CONFIDENTIAL INFORMATION, AND INCLUDING ALL INTELLECTUAL
              PROPERTY RELATING THERETO, OR THIS AGREEMENT, MUST COMMENCE AND BE FILED WITHIN ONE (1) YEAR AFTER
              THE CAUSE OF ACTION AROSE; OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.
            </li>
          </ol>
          <p style={styles.indent1}>
            9.2 <span style={styles.bold}>
              Release. The Licensee releases and forever discharges FARMERS EDGE from and against any and all demands,
              causes of action, liability and claims, at law or in equity, of any nature or kind, including, without
              limitation, that the Licensee, or its successors or assigns, can, has ever had, now or may hereafter have
              arising out of or connected in any way with the Software, the Results, the Licensee Content and/or the
              Confidential Information, and all Intellectual Property relating thereto.
            </span>
          </p>
          <p style={styles.indent1}>
            9.3 <span style={styles.bold}>
              Indemnity. Except if caused by the negligent act or omission of FARMERS EDGE, the Licensee shall
              indemnify and hold harmless FARMERS EDGE from and against any and all claims, damages, losses,
              expenses or liability of any kind whatsoever from third parties relating to:
            </span>
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2, ...styles.bold}}>
            <li>
              the Licensee’s breach of any provision, representation, warranty or covenant of this Agreement; or
            </li>
            <li>
              any loss, injury, death, damage, expense, charge or cost that FARMERS EDGE may suffer or incur,
              whether in respect of injury to persons or damage to its property, end-users, or others in any manner
              that arises out of, or is attributable to the use or access by the Licensee of the Software, the Results
              and/or the Confidential Information, and all Intellectual Property relating thereto, or any other item
              provided by FARMERS EDGE hereunder; or
            </li>
            <li>
              the Licensee Content and the Results, including any claim in respect of infringement of a third party’s
              Intellectual Property rights. FARMERS EDGE takes no responsibility and assumes no liability for any
              Licensee Content distributed or submitted by the Licensee or any third party.
            </li>
          </ol>
          <p style={styles.bold}>
            10. TERMINATION
          </p>
          <p style={styles.indent1}>
            10.1 <span style={styles.bold}>Term. </span>
            The term of this Agreement will commence on the date of your acceptance of this Agreement and shall remain
            in effect until terminated as provided in this Agreement or in any transaction agreement between you and
            FARMERS EDGE (the “Term”).
          </p>
          <p style={styles.indent1}>10.2 <span style={styles.bold}>Termination. </span> The parties agree that:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              FARMERS EDGE shall have the right to terminate this Agreement, at any time and without cause, upon the
              provision of one (1) month’s written notice to the Licensee.
            </li>
            <li>
              In the event the Licensee fails to pay the Subscription Fee or other amounts due to FARMERS EDGE pursuant
              to this Agreement or any transaction agreement between FARMERS EDGE and you, FARMERS EDGE can immediately
              terminate this Agreement and the rights and licences granted hereunder.
            </li>
            <li>
              Subject to Section 10.2(a) and Section 10.2(b), in the event that a party (the “Defaulting Party”)
              shall breach any material provision of this Agreement or fail to observe or perform any covenant or
              obligation applicable to it under this Agreement, the other party (the “Non-Defaulting Party”) has the
              right to serve written notice on the Defaulting Party of the Non-Defaulting Party’s intent to terminate
              this Agreement. The notice of intent to terminate shall specify the alleged breach or failure and if
              within thirty (30) business days of the date of delivery of such notice to the Defaulting Party, the
              Defaulting Party has not cured all of the defaults, the Non-Defaulting Party may, at its sole discretion,
              terminate this Agreement. Such termination shall be without prejudice to any other rights or remedies
              the Non-Defaulting Party may have in respect of such default.
            </li>
            <li>
              The Licensee agrees to pay any outstanding amounts owing to FARMERS EDGE to the effective date of
              termination of this Agreement.  Such termination shall not relieve any of the parties from obligations
              incurred prior to the date of such termination and shall not relieve the Licensee from any of the
              obligations which survive any termination for any reason of this Agreement.
            </li>
            <li>
              If any party becomes insolvent or bankrupt, dissolves or winds up, this Agreement terminates immediately.
            </li>
            <li>
              Where either party is given a right to terminate hereunder and does not exercise the same,
              such forbearance shall not be deemed to be a waiver of such party's right to terminate upon any
              subsequent or future event by which such party has, or is provided with, the right to terminate
              this Agreement.
            </li>
          </ol>
          <p style={styles.indent1}>10.3 <span style={styles.bold}>Return. </span>
            Upon the expiration or termination of this Agreement, for any reason whatsoever:
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              The Licensee shall forthwith deliver to FARMERS EDGE, without charge, the Confidential Information,
              the Software and the Results, and all Intellectual Property relating thereto, including all copies, and
              the Licensee shall certify to FARMERS EDGE that no copies of such material have been retained and have
              been destroyed.
            </li>
            <li>
              The Licensee shall immediately cease any and all access and use of the Software, the Results, the
              Confidential Information and any other item provided by FARMERS EDGE hereunder, and any Intellectual
              Property relating thereto, disclosed or provided by FARMERS EDGE to the Licensee in any manner
              whatsoever.
            </li>
            <li>
              The Licence will cease and terminate. The Licensee’s access and use to the Software and the Results shall
              be disabled. The Content Licence shall continue.
            </li>
            <li>
              The Licensee agrees that FARMERS EDGE has the right to notify any persons it deems necessary or
              appropriate as to the termination or expiry of the rights granted hereunder.
            </li>
          </ol>
          <p style={styles.bold}>
            11. GENERAL
          </p>
          <p style={styles.indent1}>
            11.1 <span style={styles.bold}>Governing Law. </span>
            This Agreement will be construed and the legal relationships between the parties determined in accordance
            with the laws of the Province of Manitoba and the laws of Canada, without regard to conflicts of laws
            principles, and the parties expressly attorn to the exclusive jurisdiction of the courts of Manitoba
            for enforcement thereof. Notwithstanding the foregoing, either party may apply to the court to obtain
            injunctive relief and any other available equitable or legal remedy regarding any matter relating to
            their confidentiality or proprietary rights. You and FARMERS EDGE expressly exclude the UN Convention
            on Contracts for the International Sale of Goods and The International Sale of Goods Act (Manitoba),
            as amended, replaced or re-enacted from time to time.  You agree to waive any right that you may have
            to: (i) a trial by jury; and (ii) commence or participate in any class action against FARMERS EDGE
            related to the Software, the Results, the Licensee Content and this Agreement. You also agree to opt
            out of any class proceedings against FARMERS EDGE.
          </p>
          <p style={styles.indent1}>
            11.2 <span style={styles.bold}>Arbitration. </span>
            In the event of any dispute arising between the parties concerning the subject matter of this Agreement,
            its enforceability or the interpretation thereof (the “Disagreement”):
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              the parties shall attempt to amicably resolve the Disagreement;</li>
            <li>
              if the Disagreement is not resolved pursuant to Section 11.2(a) within thirty (30) days (or such longer
              period as may be agreed upon between the parties), the parties shall refer the Disagreement to their
              respective Chief Executive Officers for resolution, or their nominees, if applicable;
            </li>
            <li>
              if the Disagreement is not resolved pursuant to Section 11.2(b) within thirty (30) days (or such longer
              period as may be agreed upon between the parties), a mediator shall be appointed by the parties who
              shall assist the parties in resolving the Disagreement;
            </li>
            <li>
              if the Disagreement is not resolved under Section 11.2(c) within thirty (30) days (or such longer period
              as may be agreed upon between the parties), any party may refer the Disagreement to be resolved by
              arbitration conducted as follows:
            </li>
          </ol>
          <ol type='i' style={styles.indent3}>
            <li>
              any party may require arbitration by giving written notice to arbitrate to the other parties, which
              written notice shall identify the nature of the Disagreement;
            </li>
            <li>
              if the parties are able to agree upon a single arbitrator, the arbitration shall be conducted before
              the single arbitrator;
            </li>
            <li>
              if the parties have been unable to agree upon the selection of a single arbitrator within two (2)
              weeks after receipt of the notice requiring arbitration, such arbitrator shall be appointed by a Judge
              of the Court of Queen’s Bench of the Province of Manitoba upon the application of any of the parties,
              and a Judge of the Court of Queen’s Bench of the Province of Manitoba shall be entitled to act as such
              arbitrator, if he or she so desires;
            </li>
            <li>
              the arbitrator shall, as soon as reasonably possible, proceed to hear and determine the Disagreement.
              The parties agree that it is important that all Disagreements be resolved promptly and the parties,
              therefore, agree that the arbitration shall be required to be conducted expeditiously and that the
              final disposition shall be accomplished within three (3) weeks or as soon thereafter as reasonably
              possible. The parties shall ensure that the arbitrator upon accepting the nomination shall agree
              that the arbitrator has time available for the timely handling of the arbitration in order to reasonably
              expect to achieve final disposition within three (3) weeks;
            </li>
            <li>
              the decision of the arbitrator shall be rendered in writing, with reasons, and shall be promptly served
              upon all parties. The decision of the arbitrator shall be binding upon the parties;
            </li>
            <li>
              in the event of the death, resignation, incapacity, neglect or refusal to act of an arbitrator,
              and if the neglect or refusal continues for a period of five (5) days after notice in writing of
              such has been given by any party, another arbitrator shall be nominated or appointed, as described
              above, to replace the arbitrator;
            </li>
            <li>
              the cost of the arbitration shall be in the discretion of the arbitrator, and shall be borne by each
              party in accordance with the decision of the arbitrator; and
            </li>
            <li>
              except as to matters otherwise provided herein, the arbitration shall be conducted in accordance
              with The Arbitration Act (Manitoba) or any successor legislation then in force. The place of
              arbitration shall be Winnipeg, Manitoba. The language to be used in the arbitration proceedings
              shall be English.
            </li>
          </ol>
          <p>
            This Section shall not prevent a party hereto from applying to a court of competent jurisdiction for
            interim protection such as, by way of example, an interim injunction.
          </p>
          <p style={styles.indent1}>
            11.3 <span style={styles.bold}>Currency. </span>
            All references to dollar amounts in this Agreement shall be lawful money of the United States of America,
             unless indicated otherwise.
          </p>
          <p style={styles.indent1}>
            11.4 <span style={styles.bold}>General. </span>
            All rights and remedies of each party under this Agreement are cumulative and may be exercised at any time
            and from time to time, independently or in combination. If any provision of this Agreement is determined
            by a court of competent jurisdiction to be invalid, illegal or unenforceable in any respect, such
            determination shall not impair or affect the validity, legality or enforceability of any other
            provision of this Agreement. No party shall be bound by any waiver of any provision of this Agreement
            unless such waiver is consented to in writing by that party.  No waiver of any provision in this
            Agreement shall constitute a waiver of any other provision, nor shall any waiver constitute a continuing
            waiver unless otherwise provided. Time shall be of the essence herein.  The Licensee and FARMERS EDGE are
            independent contractors.  No agency relationship or partnership exists between them, and neither of them
            has the right to enter into a contract on behalf of or as an agent or representative of the other.  The
            parties shall execute and deliver, or cause to be executed and delivered, upon written request, any and all
            further documents and do all acts and things or cause such acts or things to be performed which may be
            necessary or desirable to give effect to the terms of this Agreement. The parties acknowledge that this
            Agreement and any existing transaction agreements between you and FARMERS EDGE, together with any schedules
            and appendices attached thereto, constitutes the entire agreement between the parties and supersedes all
            previous representations or agreements, written or oral, between the parties hereto. You consent to the
            exchange of information and documents between us electronically over the internet or by email.
            You agree that this electronic agreement shall be equivalent of a written paper agreement between us.
          </p>
          <p style={styles.indent1}>
            11.5 <span style={styles.bold}>Notice. </span>
            Any notice required or authorized under this Agreement to be given by any party to the other parties
            shall be in writing and may be delivered in person or by courier or sent by prepaid registered mail
            and addressed to the addresses described on any transaction agreement between you and FARMERS EDGE or
            such other parties or such other addresses as a party shall notify the other parties in writing.
            Any notice given shall be deemed to be received on the date of delivery by person or by courier, as
            the case may be, or on the fifth business day following the date of mailing.
          </p>
          <p style={styles.indent1}>
            11.6 <span style={styles.bold}>Language of Agreement. </span>
            The parties hereto confirm that it is their wish that this Agreement, as well as other documents
            related hereto, including notices, have been and shall be drawn up in the English language only.
            Les parties aux présentes confirment leur volonté à cette convention de même que tous les documents,
            y compris tout avis qui s’y rattache, sont rédigés en anglais seulement.
          </p>
          <p style={styles.indent1}>
            11.7 <span style={styles.bold}>Other Remedies. </span>
            Except as expressly provided herein to the contrary, the exercise of a right of termination or any other
            right or remedy by either party shall be without prejudice to such party's right, subject to the
            limitations set forth in this Agreement, to pursue any other right or remedy available hereunder or under
            applicable law.
          </p>
          <p style={styles.indent1}>
            11.8 <span style={styles.bold}>Survival. </span>
            Any indemnity or any obligation of confidence under this Agreement is independent and survives termination
            or expiration of this Agreement.  All obligations under this Agreement that necessarily extend beyond
            termination or expiration of this Agreement in order to fully achieve their intended purpose shall survive
            termination or expiration of this Agreement, including without limiting the generality of the foregoing,
            all indemnification provisions, intellectual property provisions, confidentiality provisions, licence
            provisions, representations, warranties, covenants, ownership provisions, disclaimers and limitation of
            liability provisions.
          </p>
          <p style={styles.indent1}>
            11.9 <span style={styles.bold}>Assignment & Enurement. </span>
            The Licensee may not assign, transfer or encumber this Agreement, or any of its rights or obligations
            hereunder, without the prior written consent of FARMERS EDGE. Any attempted assignment, transfer or
            encumbrance without the required consent shall be void. The consent of FARMERS EDGE to any assignment of
            this Agreement shall not constitute FARMERS EDGE’s consent to a further assignment. Notwithstanding this
            Section, this Agreement shall be binding upon and enure to the benefit of the parties hereto and their
            respective heirs, executors, personal representatives, successors and permitted assigns.
          </p>
          <p style={styles.indent1}>
            11.10 <span style={styles.bold}>Force Majeure. </span>
            Neither party shall be liable for any failure or delay in performing its obligations under this Agreement,
            or for any loss or damage resulting therefrom, due to acts of God, the public enemy, terrorist activities,
            riots, fires, and similar causes beyond such party’s control.  In the event of such failure or delay, the
            date of delivery or performance shall be extended for a period not to exceed the time lost by reason of the
            failure or delay; provided that the party affected by such delay is using commercially reasonable efforts
            to mitigate or eliminate the cause of such delay or its effects.
          </p>
          <p style={styles.indent1}>
            11.11 <span style={styles.bold}>Non-Solicitation. </span>
            Both during this Agreement and after the termination or expiration of this Agreement for a period of one (1)
            year, the Licensee shall not nor attempt to, directly or indirectly, whether for the Licensee’s own benefit
            or for the benefit of any other entity or individual, solicit, encourage, induce or in any way influence
            any person employed by, or engaged to render services on behalf of FARMERS EDGE, to leave FARMERS EDGE or
            to engage in any activity contrary to or conflicting with the interests of FARMERS EDGE.
          </p>
          <p style={styles.indent1}>
            11.12 <span style={styles.bold}>Injunctive Relief. </span>
            Notwithstanding this Agreement, any breach of the Articles titled “CONFIDENTIALITY”,
            “INTELLECTUAL PROPERTY”, “LICENCES”, “ACKNOWLEDGEMENTS & COVENANTS”, or “INFRINGEMENT” is a breach of this
            Agreement that may cause serious and irreparable harm to FARMERS EDGE.  Any such breach will entitle
            FARMERS EDGE to injunctive relief, in addition to all other legal or equitable remedies that may be
            available.
          </p>
          <p style={styles.indent1}>
            11.13 <span style={styles.bold}>Anti-Spam Consent. </span>
            In the event that Canada's Anti-Spam Legislation applies to the installation of the Software and related
            upgrades, FARMERS EDGE hereby seeks and the Licensee hereby provides consent to FARMERS EDGE for such
            installation and potential future upgrades installation so that the Licensee may use the Software, provided
            that the Licensee may revoke such consent at any time. The function and purpose of the Software that is to
            be installed or may have upgrades is described in this Agreement. The mailing address and contact
            information for FARMERS EDGE is noted in this Agreement.
          </p>
          <p style={styles.indent1}>
            11.14 <span style={styles.bold}>Changes to EULA. </span>
            FARMERS EDGE reserves the right, at its sole discretion, to change, amend, modify, add or remove terms and
            conditions contained in this Agreement, at any time, without further notice by posting any changes on the
            Software.  Any new terms or conditions will be effective as soon as they are posted. It is your
            responsibility to check this Agreement and the Software periodically and you are deemed to be aware of such
            changes. Your continued use of the Software and/or the Results following the posting of such changes will
            mean that you accept and agree to the changes.  If you do not agree to the changes, please stop using the
            Software and the Results.
          </p>
          <p style={styles.indent1}>
            11.15 <span style={styles.bold}>Unsolicited Commercial Electronic Messages. </span>
            The inclusion of any email addresses on the Software, the Results or within this Agreements does not
            constitute consent to receiving unsolicited commercial electronic messages or SPAM.
          </p>
          <p style={styles.indent1}>
            11.16 <span style={styles.bold}>Contact Us. </span>
            If you have any questions, concerns or comments, please contact us at:
          </p>
          <section style={styles.parg}>
            <p style={styles.bold}>Farmers Edge Inc.</p>
            <p><span style={styles.bold}>Mailing Address:</span> 25 Rothwell Road, Winnipeg, MB R3P 2M5</p>
            <p><span style={styles.bold}>Telephone No.:</span> 1 (888) 576-6777</p>
            <p><span style={styles.bold}>E-mail:</span> support@farmersedge.ca</p>
          </section>
          <section style={styles.section}>
            B. PRIVACY POLICY
          </section>
          <p style={styles.parg}>
            Link to Privacy Policy:{' '}
            <a target='_blank' href='https://portal.agphdsoils.com/privacy-policy'>
              https://portal.agphdsoils.com/privacy-policy
            </a>
          </p>
          <section style={styles.section}>
            C. TERMS OF USE
          </section>
          <p style={{...styles.bold, ...styles.parg}}>
            PLEASE READ THESE TERMS (as defined below) CAREFULLY BEFORE USING THIS WEBSITE.  BY USING THIS WEBSITE,
            YOU AGREE TO THESE TERMS.  IF YOU DO NOT AGREE WITH THESE TERMS, PLEASE DO NOT USE THIS WEBSITE.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            YOU SHOULD PRINT A COPY OF THESE TERMS FOR FUTURE REFERENCE.
          </p>
          <p style={styles.bold}>
            1. Acceptance of the Terms
          </p>
          <p style={styles.parg}>
            Welcome to the website and online service of Farmers Edge Inc. This is a legal agreement between you and
            Farmers Edge Inc. (also referred to as “Farmers Edge”, “us”, or “we”, which terms include all of the
            officers, directors, shareholders, agents, users, representatives, contractors, employees, affiliates,
            subsidiaries, licensors, licensees, suppliers and partners of Farmers Edge). These Terms govern your use
            of the Site (as defined below).
          </p>
          <p style={styles.parg}>
            The term "Site" means this website, having the URL http://www.agphdsoils.com, or any
            other website having a URL which re-directs to http://www.agphdsoils.com, as well as any related
            applications made available by Farmers Edge from time to time at the Site or in any app stores for
            use on mobile devices, tablets, personal computers and other devices, and subdomains and subsidiary
            sites, and all of the related web pages relating thereto, including, but not limited to, content,
            interfaces, user interfaces, visual interfaces, applications, software, reports, information,
            photographs, images, ideas, inventions, illustrations, audio clips, video clips, data, code, designs,
            pictures, articles, publications, graphics, text, files, icons, user accounts, titles, themes, objects,
            techniques, know-how, databases, charts, dialogue, locations, concepts, artwork, sounds, music, musical
            compositions, audio-visual effects, methods of operation, moral rights, product names, company names,
            trademarks, logos and trade names or other materials uploaded, downloaded and/or contained in or
            electronically Distributed (as defined below) on the Site or the Service (as defined below),
            including the manner in which the said content and information is presented or appears, together
            with all intellectual property rights therein.
          </p>
          <p style={styles.parg}>
            The term “Distribute(d)” means to incorporate, run, submit, use, display, copy, upload, post, reproduce,
            embed, communicate, publish, distribute, create derivative works of, adapt, translate, perform, transmit,
            arrange, modify, export, merge, transfer, share, outsource and/or make available.
          </p>
          <p style={styles.parg}>
            The term “Service” means the Site, as well as any online services offered by Farmers Edge.
          </p>
          <p style={styles.parg}>
            By registering with, accessing or using any aspect of the Service, you signify that you have read,
            understood and agree to be bound by these Terms, whether or not you are a registered user of our Service,
            including those additional terms and conditions and policies referenced herein and/or available by hyperlink
            in these Terms. You must abide by Farmers Edge policies as stated in these Terms as well as all other
            operating rules, policies and procedures that may be published from time to time on the Service, each of
            which is incorporated herein by reference and each of which may be updated by Farmers Edge from time to
            time without notice to you.
          </p>
          <p style={styles.parg}>
            Certain areas of the Site (and your access to or use of certain aspects of the Service) may have different
            terms and conditions posted or may require you to agree with and accept additional terms and conditions.
            If there is a conflict between these Terms and the terms and conditions posted for a specific area of the
            Site or a certain aspect of the Service, the latter terms and conditions will take precedence with respect
            to your use of or access to that area of the Site or Service, as applicable.
          </p>
          <p style={styles.parg}>
            BY CLICKING “I ACCEPT” OR OTHERWISE ACCESSING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD
            AND AGREE TO BE BOUND BY THESE TERMS, INCLUDING THE PRIVACY POLICY ON THE SITE, AND ANY ADDITIONAL TERMS,
            POLICIES, OPERATING RULES AND PROCEDURES REFERENCED HEREIN AND/OR AVAILABLE BY HYPERLINK IN THESE TERMS,
            OR FUTURE MODIFICATIONS AS DESCRIBED OR REFERENCED HEREIN (COLLECTIVELY, “TERMS”). If you are not
            eligible, or do not agree to these Terms, then please do not access or use the Service. These Terms
            apply to all Users (as defined below). The term “User(s)” means a person who uses and accesses the
            Service in any manner, including merely accessing or viewing the Site, and includes a registered user,
            visitor, customer, contributors of User Content (as defined below), or browser, and such a person is
            referred to in these Terms as "user" or "you”.
          </p>
          <p style={styles.parg}>
            If you are registering or using the Service on behalf of, or in connection with, your employment or
            engagement with a company, entity or organization (collectively, “Subscribing Organization”), you represent
            and warrant that you are an authorized representative of that Subscribing Organization with the authority
            to bind such organization to these Terms, and you hereby do agree to be bound by these Terms on behalf of
            such Subscribing Organization. In such a case, references to “you” in these Terms shall be construed to
            mean you, the Subscribing Organization, and any other individual that uses the Service on the Subscribing
            Organization’s behalf or in connection with their employment with or engagement by such
            Subscribing Organization. To the extent your Subscribing Organization has a separate written agreement with
            Farmers Edge, that agreement will define the order of precedence between these Terms and that separate
            agreement with respect to such Subscribing Organization, provided that you remain individually bound by
            these Terms with respect to your use of the Service.
          </p>
          <p style={styles.bold}>
            2. Account Registration
          </p>
          <p style={styles.parg}>
            In consideration of your access or use of any aspect of the Service, including the Site, you agree to: (a)
            provide true, accurate, current and complete information about yourself as prompted by any registration
            form(s) on the Service, including your geographical location and address (the "Registration Data"); and (b)
            maintain and promptly update the Registration Data to keep it true, accurate, current and complete,
            including a valid email address. If you provide any information that is untrue, inaccurate, not current
            or incomplete, Farmers Edge has the right to suspend or terminate your account and refuse any and all
            current or future use of the Service (or any portion thereof).
          </p>
          <p style={styles.parg}>
            Registered Users may receive a password and account designation upon completing the Service
            registration process. You are responsible for maintaining the confidentiality of the password,
            account designation and account and are fully responsible for all activities that occur under your password,
            account designation or account. You agree to: (a) immediately notify Farmers Edge of any unauthorized use of
            your password, account designation or account or any other breach of security; and (b) ensure that you exit
            from your account at the end of each session. You agree that Farmers Edge cannot and will not be liable for
            any loss or damage arising from your failure to keep your password and account secure.
          </p>
          <p style={styles.parg}>
            You may not transfer or sell your account and account designation to another party. If you are registering
            as a business entity or Subscribing Organization, you personally guarantee that you have the authority to
            bind the entity or Subscribing Organization to these Terms.
          </p>
          <p style={styles.parg}>
            You may not access or use the Service if you live in a jurisdiction where access or use of the Service
            or any part of it may be illegal or prohibited. It is solely your responsibility to determine whether
            your access or use of the Service is lawful, and you must comply with all applicable laws. We reserve
            the right to request proof of identification and residence.
          </p>
          <p style={styles.parg}>
            The Service is not available to temporarily or indefinitely suspended Users. Farmers Edge reserves the
            right, in the sole discretion of Farmers Edge, to cancel unconfirmed or inactive accounts. Farmers Edge
            reserves the right to refuse the Service to anyone, for any reason, at any time.
          </p>
          <p style={styles.bold}>
            3. Privacy
          </p>
          <p style={styles.parg}>
            Farmers Edge collects, uses and discloses Users’ personal information in accordance with its Privacy Policy,
            which is available by clicking here www.agphdsoils.com. The Farmers Edge Privacy Policy may be changed from
            time to time by Farmers Edge in its discretion without any notice or liability to you or any other person
            by making an amended Privacy Policy accessible through the Service.  By accepting these Terms, and each
            time you use and access the Service, you consent to the collection, use and disclosure of your personal
            information by Farmers Edge in accordance with the Privacy Policy as it then reads.
          </p>
          <p style={styles.bold}>
            4. Changes to Terms of Use
          </p>
          <p style={styles.parg}>
            Farmers Edge reserves the right, at its sole discretion, to change, amend, modify, delete or add to the
            terms and conditions contained in these Terms, at any time, without further notice by posting any changes
            on the Service.  Any new terms or conditions will be effective as soon as they are posted, and by continuing
            to access or use the Service, you will be deemed to have accepted the new terms and conditions. It is your
            responsibility to check these Terms periodically and you are deemed to be aware of such changes. If you do
            not agree to the changes, please stop using the Service.
          </p>
          <p style={styles.bold}>
            5. Paid Services
          </p>
          <p style={styles.parg}>
            The Service is for convenience and informational purposes only and is not intended to convey advice or
            recommendations, or an offer to sell any product or service.  The Terms are in addition to any other
            agreement you may have with Farmers Edge, including a transaction agreement.  Your use of the Service
            includes the ability to enter into agreements and/or to make offers to purchase electronically.
            IF YOU CHOOSE TO ENTER INTO AGREEMENTS AND/OR TO MAKE OFFERS TO PURCHASE ELECTRONICALLY, YOU ACKNOWLEDGE
            THAT YOUR ELECTRONIC COMMUNICATIONS ARE SUFFICIENT TO CONSTITUTE YOUR AGREEMENT AND INTENT TO BE BOUND BY
            AND TO PAY FOR SUCH AGREEMENTS AND PURCHASES. YOUR AGREEMENT AND INTENT TO BE BOUND BY ELECTRONIC
            COMMUNICATIONS APPLIES TO ALL RECORDS RELATING TO ALL TRANSACTIONS YOU ENTER INTO ON THE SITE AND THE
            SERVICE. In order to access and retain your electronic records, you may be required to have certain
            hardware and software, which are your sole responsibility.
          </p>
          <p style={styles.parg}>
            Certain aspects of the Service may be provided for a fee or other charge.  These fees and charges are
            described on the Service, and in the event you elect to use paid aspects of the Service, you agree to
            the pricing, payment and billing policies applicable to such fees and charges, posted or linked at the
            Service when you elect to use the paid aspects of the Service.  Farmers Edge may add new services for
            additional fees and charges, or amend fees and charges for existing services, at any time in its sole
            discretion.
          </p>
          <p style={styles.bold}>
            6. Intellectual Property Ownership
          </p>
          <p style={styles.parg}>
            The Service is the proprietary property of Farmers Edge Inc., its content suppliers or its licensors,
            as the case may be. Unless expressly stated otherwise, the Service is protected by Canadian and
            international copyright, trademark and other applicable laws.  You do not acquire ownership rights
            or any implied right to the Service that you obtained, accessed, used or viewed via the Service.
          </p>
          <p style={styles.bold}>
            7. Trademarks
          </p>
          <p style={styles.parg}>
            The Marks (as defined below) are registered or unregistered trademarks, trade dress, designs, domain
            names, logos or trade names owned or licensed by Farmers Edge. All other trademarks, trade dress,
            designs, domain names, trade names and logos not owned by Farmers Edge that appear on or via the
            Service are the property of their respective owners, who may or may not be affiliated with, connected to,
            or sponsored by Farmers Edge.  Any use of the Marks, except as expressly provided in these Terms, is
            strictly prohibited. Nothing appearing on or via the Service or elsewhere shall be construed as granting,
            by implication, estoppel, or otherwise, any license or right to use, display or copy, in any manner,
            any of the Marks.
          </p>
          <p style={styles.parg}>
            The term “Marks” means the FARMERS EDGE name and logo, AG PHD SOILS name and logo, SMART VR name, and any
            other trademarks, trade dress, designs, trade names, domain names and logos appearing on or in connection
            with the Service.
          </p>
          <p style={styles.bold}>
            8. Licence
          </p>
          <p style={styles.parg}>
            We acknowledge that when you obtain access to the Service, your computer downloads a copy of the information
            that is on it. Provided that you are eligible for use of the Service and subject to these Terms,
            Farmers Edge hereby grants to you a limited personal, non-exclusive, non-sublicensable, revocable,
            non-assignable and non-transferable right and license, worldwide, to access, read, display on your
            computer, download and print a single copy of the text and images which are available on the Site
            (including any forms available on the Site which are designated for printing), solely for your personal
            and non-commercial use in connection with viewing the Site on any computer and any mobile devices, tablets,
            personal computers and other devices which you own and control, subject to any usage rules or other
            restrictions set out by the device manufacture, app store provider or platform operator for the term
            of these Terms (the “License”). The License is personal to you, and may not be assigned, transferred
            or sub-licensed to any other person.
          </p>
          <p style={styles.parg}>
            Without limiting the generality of the foregoing, you may not make any commercial use of the Service,
            include the Service in or with any product or service that you create or distribute, or copy the Service
            onto your, or any other person’s, website.  Farmers Edge retains all rights not expressly granted hereunder.
          </p>
          <p style={styles.parg}>
            You will keep all copyright and other proprietary notices intact. Your use of the Service does not transfer
            to you any ownership or other rights in the Service. You may use the Service only in the manner described
            expressly in these Terms and subject to all applicable laws. The Service may NOT be Distributed, forwarded,
            framed, reproduced, republished, downloaded, uploaded, incorporate, sold or exploited in any form or by any
            means, in whole or in part, without the prior written permission of Farmers Edge, except as expressly
            permitted by these Terms or by applicable copyright laws. Using the Service for any other purpose or in
            any other manner is strictly prohibited.
          </p>
          <p style={styles.parg}>
            ANY USE OF THE SERVICE, OTHER THAN AS SPECIFICALLY AUTHORIZED UNDER THESE TERMS, WITHOUT THE PRIOR WRITTEN
            PERMISSION OF FARMERS EDGE, IS STRICTLY PROHIBITED AND WILL TERMINATE THE LICENSE. SUCH UNAUTHORIZED USE
            MAY ALSO VIOLATE APPLICABLE LAWS, INCLUDING WITHOUT LIMITATION COPYRIGHT AND TRADEMARK LAWS, AND APPLICABLE
            REGULATIONS AND STATUTES. THE LICENSE IS REVOCABLE BY FARMERS EDGE AT ANY TIME WITHOUT NOTICE AND WITH OR
            WITHOUT CAUSE.
          </p>
          <p style={styles.bold}>
            9. User Content
          </p>
          <p style={styles.parg}>
            Please do not Distribute User Content (as defined below) on or through the Service.  We want to avoid the
            possibility of future misunderstandings when projects developed by us or under our direction might seem to
            others to be similar to their own creative work.  We therefore ask that you not Distribute any User
            Content. “User Content” means user-generated content about the products and services of Farmers Edge,
            including questions, suggestions, information, inquiries, testimonials, feedback, reviews, emails, ideas,
            drawings, comments, opinions, audio, videos, photographs, or other content or material, including any
            intellectual property rights relating thereto. The term “User Content” does not include any Licensee
            Content (as defined in the End User Licence Agreement which is available on the Site).
          </p>
          <p style={styles.parg}>
            If you do Distribute User Content on or through the Service, all right, title and
            interest in the User Content shall be deemed the sole exclusive property of Farmers Edge.  When you
            Distribute User Content, you assign and transfer and/or shall cause the assignment and transfer over
            to Farmers Edge of any right, title and interest, world-wide, you may have or may in the future acquire
            in and to the User Content, without any remuneration.  You agree, at the request of Farmers Edge, to
            do or to cause all lawful acts to secure and protect the rights and interests of Farmers Edge in the
            User Content, without any compensation, but without expense to you, and you agree, when requested by
            Farmers Edge, to execute, acknowledge and deliver to Farmers Edge, without compensation but without
            expense to you, any and all instruments, assignments, waivers and documents relating thereto.
            You waive all of your moral rights in the User Content that you make available on or through the
            Service in favor of Farmers Edge.
          </p>
          <p style={styles.parg}>
            When you Distribute User Content on or through the Service, you represent and warrant: (1) that you own
            or otherwise control all of the rights to the User Content or that you otherwise have obtained all rights
            and consents that are necessary to transfer ownership of the User Content to Farmers Edge; (2) that the
            User Content is accurate; (3) that use and Distribution of the User Content will not infringe the rights
            of any third party and will not otherwise cause injury to any person or entity; (4) that you will
            immediately notify us of any User Content that does not comply with these Terms or may infringe the rights
            of a third party or third parties; and (5) that the User Content is original to you and that no other party
            has any rights thereto.
          </p>
          <p style={styles.parg}>
            YOU AGREE TO INDEMNIFY FARMERS EDGE FOR ALL CLAIMS BROUGHT BY A THIRD PARTY AGAINST FARMERS EDGE ARISING
            OUT OF YOUR USER CONTENT, INCLUDING ANY CLAIM IN RESPECT OF INFRINGEMENT OF A THIRD PARTY’S INTELLECTUAL
            PROPERTY RIGHTS OR A CLAIM ARISING OUT OF OR IN CONNECTION WITH A BREACH OF ANY OF THE ABOVE REPRESENTATIONS
            AND WARRANTIES. FARMERS EDGE TAKES NO RESPONSIBILITY AND ASSUMES NO LIABILITY FOR ANY USER CONTENT
            DISTRIBUTED BY YOU OR ANY THIRD PARTY.
          </p>
          <p style={styles.parg}>
            Farmers Edge considers any User Content Distributed on or through the Service to be non-confidential, and
            Farmers Edge shall not be liable for the disclosure or use of such User Content.  If, at Farmers Edge’s
            request, you send User Content to improve the Service, Farmers Edge will also consider that User Content
            to be non-confidential, and Farmers Edge will not be liable for the use or disclosure of the User Content.
            Any communication by you to Farmers Edge is subject to these Terms.
          </p>
          <p style={styles.parg}>
            If applicable, Farmers Edge shall have the right but not the obligation to monitor, edit, refuse to post or
            remove any User Content. Without limiting the foregoing, Farmers Edge shall have the right to remove any
            material that Farmers Edge, in its sole discretion, finds to be in violation of the provisions of these
            Terms, or otherwise objectionable.  Although Farmers Edge reserves the right to remove, without notice,
            any User Content for any reason, Farmers Edge has no obligation to delete User Content that you may
            find objectionable or offensive.
          </p>
          <p style={styles.bold}>
            10. Modifications to this Service
          </p>
          <p style={styles.parg}>
            Notwithstanding any other provision of these Terms and without prejudice to any other rights we may have,
            Farmers Edge may, in its discretion and for its convenience, at any time, change, discontinue, delete,
            deactivate, modify, restrict, suspend or terminate, immediately, temporarily or permanently, these Terms,
            your password, your account, the User Content and/or the Service, or any part thereof, without any notice or
            liability to you or any other person, for any reason.  Farmers Edge may also impose limits on certain
            features and services or restrict your access and use to parts or all of the Service without notice or
            liability.
          </p>
          <p style={styles.bold}>
            11. Links and Framing</p>
          <p style={styles.parg}>
            While the Service may contain links to external sites or resources, Farmers Edge is not responsible for the
            content of any of the linked external sites or resources. Farmers Edge provides these links as a
            convenience. The provision of a link or resource does not imply that there is any association between us
            and the operators of the external site or resource. FARMERS EDGE DOES NOT ENDORSE ANY EXTERNAL SITE OR
            RESOURCE OR ACCEPT RESPONSIBILITY OR LIABILITY FOR ITS CONTENT, PRODUCTS, SERVICES, ACCURACY, AUTHENTICITY,
            TIMELINESS OR COMPLETENESS. Your use of any external site and resources is governed by the terms of use of
            that site or resource. You access these linked external sites and resources at your own risk. You may find
            some content to be offensive, harmful, inaccurate, or deceptive. You agree that Farmers Edge shall not be
            responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or
            in connection with the use of or reliance on any such content, products or services available on or through
            any such external sites or resources.
          </p>
          <p style={styles.parg}>
            The Service may contain the opinions, advice, statements and views of other Users. Given the interactive
            nature of the Service, we cannot endorse, guarantee, or be responsible for the accuracy, efficacy, or
            veracity of any content generated by our Users. Any opinions, advice, statements and views expressed
            or made available by third parties, including Users, are those of the respective author(s) or
            distributor(s) and not of Farmers Edge. FARMERS EDGE NEITHER ENDORSES NOR IS RESPONSIBLE FOR THE
            ACCURACY OR RELIABILITY OF ANY OPINION, ADVICE, STATEMENT OR VIEW MADE ON THE SERVICE BY ANYONE
            OTHER THAN AUTHORIZED FARMERS EDGE EMPLOYEE SPOKESPERSONS WHILE ACTING IN THEIR OFFICIAL CAPACITIES.
          </p>
          <p style={styles.bold}>
            12. Rules of Conduct
          </p>
          <p style={styles.parg}>
            You agree that you will be personally responsible for your use of the Service and for all of your
            communication and activity in using the Service, including any User Content you contribute.
          </p>
          <p style={styles.parg}>
            YOU AGREE AT ALL TIMES TO INDEMNIFY, DEFEND AND HOLD FARMERS EDGE HARMLESS FROM ANY AND ALL LIABILITY
            OR DAMAGES ARISING FROM YOUR CONDUCT ON THE SERVICE, INCLUDING ANY USER CONTENT THAT YOU CONTRIBUTE
            AND/OR INFRINGEMENT OF A THIRD PARTY’S INTELLECTUAL PROPERTY RIGHTS.
          </p>
          <p style={styles.parg}>
            As a condition of using the Service, you agree to all of the following:
          </p>
          <ol type='i' style={styles.indent3}>
            <li>
              You are solely responsible for your conduct and any User Content that you Distribute on the
              Service or that you allow others to Distribute on the Service under your account.
            </li>
            <li>
              You will not Distribute any User Content to, on or through the Service that is fraudulent, unlawful,
              harmful, threatening, abusive, harassing, tortious, defamatory, obscene, libelous, slanderous,
              pornographic, invasive of another's privacy, or hateful.
            </li>
            <li>
              You will not Distribute any User Content that infringes or violates a patent, trademark, trade secret,
              copyright or other intellectual property rights of another person or entity, or that violate any right of
              privacy, or offer content that you do not have a right to make available under any law or under
              contractual or fiduciary relationships.
            </li>
            <li>
              You will not transmit any worms or viruses, spyware, malware, bugs or any other harmful or destructive
              code to or through the Service.
            </li>
            <li>
              You will not Distribute to users any unsolicited or unauthorized advertising, promotional materials,
              "junk mail," "spam," "chain letters," "pyramid schemes," "affiliate links," or any other form of
              solicitation.
            </li>
            <li>
              You may not link to or frame the Service, or any portion thereof, except as provided herein.  Farmers
              Edge does not permit activities such as bring-up or presenting content of the Service within another
              website.  In this regard, without limiting the provisions contained in these Terms, you may not frame
              any webpage from the Service.  Further, you may not archive, cache or mirror any of the Service, or any
              part thereof.
            </li>
            <li>
              You will not use the Service for any illegal or unauthorized purpose or violate any applicable state,
              federal or local laws in your jurisdiction (including but not limited to intellectual property laws,
              criminal laws against money laundering, or tax laws).
            </li>
            <li>
              You will not "stalk" or otherwise harass anyone on or through the Service.
            </li>
            <li>
              You will not pretend that you are, or that you represent, someone else, or impersonate any other
              individual or entity, or falsely state or otherwise misrepresent your affiliation with an individual
              or entity.
            </li>
            <li>
              You will not access another registered user’s account without that registered user’s permission,
              nor will you compromise another registered user’s account.  You agree that if such acts are brought
              to the attention of Farmers Edge, Farmers Edge may (1) immediately terminate your account, if any;
              and (2) provide all relevant information to law enforcement officials in order to assist in an
              investigation of your actions.
            </li>
            <li>
              You will not violate nor attempt to violate the security of the Service, including, without limitation:
            </li>
            <ol type='a' style={styles.indent3}>
              <li>
                accessing data not intended for you, including logging into a server or account which you not authorized
                to access;
              </li>
              <li>
                attempting to probe, scan or test the vulnerability of a system or network to breach security or
                authentication measures without proper authorization;
              </li>
              <li>
                using any "deep-link", "page-scrape", "robot", "spider" or other automatic device, program, algorithm or
                methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any
                portion of the Service or any content, or in any way reproduce or circumvent the navigational structure
                or presentation of the Service or any content, to obtain or attempt to obtain any materials, documents
                or information through any means not purposely made available through the Service;
              </li>
              <li>
                taking any action that imposes an unreasonable or disproportionately large load on the infrastructure
                of the Service or the systems or networks of Farmers Edge, or any systems or networks connected to the
                Service or the systems of Farmers Edge;
              </li>
              <li>
                conducting a reverse look-up, tracing or seeking to trace any information on any other user to its
                source, or exploit the Service or information made available or offered by or through the Service,
                in any way where the purpose is to reveal any information, including but not limited to personal
                identification or information, other than your own information, as provided for by the Service;
              </li>
              <li>
                attempting to interfere with, disrupt or disable service to any user, host or network, including,
                without limitation, via means of "denial of service" attacks, overloading, "flooding", "mailbombing"
                or "crashing";
              </li>
              <li>
                disrupting network nodes or network services or otherwise restricting, inhibiting, disrupting or
                impeding the ability of Farmers Edge to monitor or make available the Service; or
              </li>
              <li>
                taking any action in order to obtain services to which you are not entitled.
              </li>
            </ol>
            <li>
              You shall not transmit email or any other content that includes personal or identifying information about
              another person without that person's explicit consent.
            </li>
            <li>
              You shall not sublicense, reproduce, duplicate, rent, lease, sell, resell, exploit, redistribute,
              reverse engineer, broadcast, Distribute, disseminate, decompile, publish, translate, adapt or vary
              any of the Service, or any portion thereof, including but not limited to the Site, in any form or
              by any means whatsoever, be they physical, electronic or otherwise.
            </li>
            <li>
              The term “Service” means the Site, as well as any online services
            </li>
            <li>
              You shall not remove any copyright, trademark or proprietary notices from any copies of the Service.
            </li>
            <li>
              You shall not create a database in electronic or structured manual form by systematically
              downloading and storing all or any of the Service.
            </li>
            <li>
              Your use of the Service cannot in any way harm or prejudice the image or perception of the Service
              or Farmers Edge to others receiving the information on the Service.
            </li>
          </ol>
          <p style={styles.bold}>
            13. Termination
          </p>
          <p style={styles.parg}>
            Notwithstanding any other provision of these Terms and without prejudice to any other rights we may have,
            Farmers Edge may, in its discretion and for its convenience, at any time, change, discontinue, delete,
            deactivate, modify, restrict, suspend or terminate, immediately, temporarily or permanently, these Terms,
            your password, your account, the User Content and/or the Service, or any part thereof, without any notice
            or liability to you or any other person, for any reason.
          </p>
          <p style={styles.parg}>
            If we terminate your account, your right to use the Service will immediately cease.
            You may terminate your account at any time and for any reason, and we will make available through the
            Service reasonable means for you to do so. If you do not comply with these Terms at any time, Farmers Edge
            reserves the right to immediately suspend or terminate your access to the Service, or any part thereof,
            and/or your account, if any.
          </p>
          <p>
            Any such termination by Farmers Edge shall be in addition to and without prejudice to such rights and
            remedies as may be available to Farmers Edge, including injunction and other equitable remedies.
          </p>
          <p>
            If these Terms or your permission to access or use all or any part of the Service is terminated for any
            reason, then these Terms and all other than existing transaction agreements between you and Farmers Edge
            will continue to apply and be binding upon you regarding your prior access to and use of the Service,
            and anything connected with, relating to or arising therefrom. You agree that Farmers Edge shall not
            be liable to you or any third-party for any termination of your access and use to the Service or any
            part thereof.
          </p>
          <p>
            All provisions of these Terms will survive termination, including without limitation, the disclaimers,
            limitations on liability, warranties, representations, ownership, termination, interpretation,
            intellectual property provisions, your licenses to us and the indemnity provisions of these Terms will
            survive the termination of these Terms.
          </p>
          <p style={styles.bold}>
            14. DISCLAIMERS AND LIMITATION OF LIABILITY
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            THE LAWS OF CERTAIN JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR CONDITIONS OR THE
            EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE BELOW
            DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MIGHT NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            YOU AGREE THAT THE SERVICE AND ALL PRODUCTS AND SERVICES
            INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE ARE PROVIDED BY FARMERS EDGE ON
            AN "AS IS" AND “AS AVAILABLE” BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING.  YOU FURTHER AGREE THAT
            YOUR USE OF THE SERVICE AND ALL PRODUCTS AND SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH
            THE SERVICE BY FARMERS EDGE SHALL BE AT YOUR SOLE RISK.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            TO THE FULLEST EXTENT PERMITTED BY LAW, WE DO NOT GIVE ANY AND IN FACT DISCLAIM ANY WARRANTY, CONDITION,
            GUARANTEE OR REPRESENTATION, EXPRESS, STATUTORY OR IMPLIED, RELATING TO THE SERVICE, THE USER CONTENT,
            THE SITES AND RESOURCES LINKED TO THE SERVICE, ALL PRODUCTS AND SERVICES INCLUDED ON OR OTHERWISE MADE
            AVAILABLE TO YOU THROUGH THE SERVICE AND YOUR ACCESS TO AND USE THEREOF, INCLUDING WITHOUT LIMITATION
            ANY IMPLIED WARRANTY, CONDITION, GUARANTEE AND/OR REPRESENTATION OF MERCHANTABILITY AND FITNESS FOR A
            PARTICULAR PURPOSE, PERFORMANCE, QUALITY, TITLE, NON-INFRINGEMENT, SECURITY, ACCURACY, COMPLETENESS OR
            SUITABILITY FOR ANY PURPOSE, OR THAT SUCH INFORMATION IS CURRENT AT ALL TIMES.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            FARMERS EDGE MAKES NO WARRANTIES, CONDITIONS, GUARANTEES OR REPRESENTATIONS ABOUT THE TRUTHFULNESS,
            ACCURACY OR COMPLETENESS OF THE USER CONTENT, THE SERVICE AND/OR THE CONTENT OF ANY SITES OR RESOURCES
            LINKED TO THE SERVICE, OR THE AVAILABILITY, QUALITY, CHARACTERISTICS, LEGITIMACY, FUNCTIONALITY,
            SECURITY OR SAFETY OF ANY SITES OR RESOURCES LINKED TO THE SERVICE, THE USER CONTENT, THE SERVICE
            AND/OR THE SERVICES AND PRODUCTS INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE,
            AND FARMERS EDGE ASSUMES NO LIABILITY OR RESPONSIBILITY THEREOF.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            FARMERS EDGE ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (a) PERSONAL INJURY OR PROPERTY DAMAGE,
            OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICE; (b) ANY UNAUTHORIZED ACCESS
            TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
            THEREIN; (c) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICE; (d) ANY BUGS, VIRUSES,
            TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICE BY ANY THIRD PARTY;
            AND/OR (e) ANY ERRORS OR OMISSIONS IN THE SERVICE AND THE USER CONTENT, OR FOR ANY LOSS OR DAMAGE OF ANY
            KIND INCURRED AS A RESULT OF THE USE OR ACCESS OF THE SERVICE OR THE USER CONTENT DISTRIBUTED OR OTHERWISE
            MADE AVAILABLE VIA THE SERVICE.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            IN NO EVENT SHALL FARMERS EDGE BE LIABLE TO YOU OR ANY OTHER PERSON FOR ANY INDIRECT, INCIDENTAL,
            CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY LOSS OR DAMAGE ARISING FROM, CONNECTED WITH, OR RELATING
            TO (a) PRODUCTS OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE;
            (b) THE SERVICE AND YOUR ACCESS AND USE THEREOF; (c) THE USER CONTENT; (d) THE SITES AND RESOURCES
            LINKED TO THE SERVICE; AND (e) THESE TERMS, INCLUDING BUT NOT LIMITED TO, LOSS OF DATA, BUSINESS,
            MARKETS, SAVINGS, INCOME, PROFITS, USE, PRODUCTION, REPUTATION OR GOODWILL, ANTICIPATED OR OTHERWISE,
            OR ECONOMIC LOSS, UNDER ANY THEORY OF LIABILITY (WHETHER IN CONTRACT, TORT, STRICT LIABILITY OR ANY OTHER
            THEORY OR LAW OR EQUITY), REGARDLESS OF ANY NEGLIGENCE OR OTHER FAULT OR WRONGDOING (INCLUDING WITHOUT
            LIMITATION GROSS NEGLIGENCE AND FUNDAMENTAL BREACH) BY FARMERS EDGE OR ANY PERSON FOR WHOM FARMERS EDGE
            IS RESPONSIBLE, AND EVEN IF FARMERS EDGE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE
            BEING INCURRED.  IN THOSE JURISDICTIONS THAT DO NOT ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY
            FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH JURISDICTIONS, THE LIABILITY OF FARMERS EDGE SHALL BE
            LIMITED TO THE FULL EXTENT PERMITTED BY LAW.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            YOU HAVE SOLE RESPONSIBILITY FOR ANY DECISIONS YOU MAKE BASED ON INFORMATION CONTAINED IN THE SERVICE.
            IF YOU USE THE SERVICE, YOU ARE AGREEING THAT THIS LIMITATION OF LIABILITY IS REASONABLE AND
            IN KEEPING WITH THE NATURE OF THE SERVICE.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU ACKNOWLEDGE AND AGREE THAT YOUR SOLE AND EXCLUSIVE
            REMEDY FOR ANY DISPUTE WITH FARMERS EDGE IS TO STOP USING THE SERVICE AND TO CANCEL YOUR ACCOUNT.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            FARMERS EDGE WILL NOT BE RESPONSIBLE FOR ANY DAMAGES YOU OR ANY THIRD-PARTY MAY SUFFER AS A RESULT OF THE
            TRANSMISSION, STORAGE OR RECEIPT OF CONFIDENTIAL OR PROPRIETARY INFORMATION THAT YOU MAKE OR THAT YOU
            EXPRESSLY OR IMPLICITLY AUTHORIZE FARMERS EDGE TO MAKE, OR FOR ANY ERRORS OR ANY CHANGES MADE TO ANY
            TRANSMITTED, STORED OR RECEIVED INFORMATION.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            TOTAL LIABILITY OF FARMERS EDGE TO YOU OR ANY THIRD PARTIES IN ANY CIRCUMSTANCE IS LIMITED TO THE GREATER
            OF (A) THE AMOUNT OF FEES YOU PAID TO FARMERS EDGE IN THE 12 MONTHS PRIOR TO THE ACTION GIVING RISE TO
            LIABILITY; AND (B) $100 (USD). SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL
            OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            IN ADDITION, NO ADVICE OR INFORMATION (ORAL OR WRITTEN) OBTAINED BY YOU FROM FARMERS EDGE SHALL
            CREATE ANY WARRANTY.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            YOU AND FARMERS EDGE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICE,
            ANY PRODUCTS OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE,
            THE USER CONTENT, YOUR ACCESS AND USE OF THE SERVICE, ANY SITES OR RESOURCES LINKED TO THE SERVICE OR
            THESE TERMS, MUST COMMENCE AND BE FILED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION AROSE; OTHERWISE,
            SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            IF YOU ARE DISSATISFIED WITH THE SERVICE, OR WITH THESE TERMS, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
            DISCONTINUE USING THE SERVICE.
          </p>
          <p style={styles.bold}>
            15. INDEMNIFICATION
          </p>
          <p style={{...styles.bold, ...styles.parg}}>
            BY ACCEPTING THESE TERMS, YOU AGREE AT ALL TIMES TO INDEMNIFY AND HOLD FARMERS EDGE HARMLESS FROM AND
            AGAINST ANY AND ALL ACTIONS, PROCEEDINGS, COSTS, CLAIMS, DAMAGES, DEMANDS, LIABILITIES AND EXPENSES,
            WHATSOEVER, INCLUDING REASONABLE LEGAL AND OTHER FEES AND DISBURSEMENTS, ARISING OUT OF, SUSTAINED,
            INCURRED OR PAID BY US, DIRECTLY OR INDIRECTLY, IN RESPECT OF (A) YOUR ACTUAL OR ALLEGED BREACH OF THESE
            TERMS; OR (B) YOUR USE AND ACCESS OF THE SERVICE; OR (C) YOUR USE OF ANY SITES OR RESOURCES LINKED TO
            THE SERVICE; OR (D) YOUR ACTUAL OR ALLEGED INFRINGEMENT BY YOU, OR ANY THIRD PARTY USING YOUR ACCOUNT
            OR PASSWORD, OF ANY INTELLECTUAL PROPERTY OR OTHER RIGHT OF ANY PERSON OR ENTITY; OR (E) ANY USER CONTENT
            YOU DISTRIBUTE ON OR THROUGH THE SERVICE OR WHICH IS SENT TO US BY E-MAIL OR OTHER CORRESPONDENCE; AND/OR
            (F) YOUR ACTUAL OR ALLEGED VIOLATION OF ANY APPLICABLE LAWS, RULES, REGULATIONS OR RIGHTS OF ANOTHER.
          </p>
          <p style={styles.bold}>
            16. Governing Law
          </p>
          <p style={styles.parg}>
            These Terms shall be governed by, and construed in accordance with the laws of Canada and of the Province
            of Manitoba, and shall be treated in all respects as a Manitoba contract, without reference to the
            principles and rules of conflicts of law.  You also agree and hereby submit to the exclusive personal
            jurisdiction and venue of the Province of Manitoba and acknowledge that you do so voluntarily and are
            responsible for complying with all local laws.  Notwithstanding the foregoing, you and Farmers Edge may
            apply to a court in any jurisdiction to obtain injunctive relief and any other available equitable or
            legal remedy regarding any matter relating to confidentiality, intellectual property rights or
            proprietary rights.
          </p>
          <p style={styles.parg}>
            You and Farmers Edge expressly exclude the application of the UN Convention on Contracts for the
            International Sale of Goods and The Sale of Goods Act (Manitoba), as amended, replaced or re-enacted
            from time to time.
          </p>
          <p style={styles.parg}>
            You agree to waive any right that you may have to (i) a trial by jury; and (ii) commence or participate
            in any class action against us related to the Service, the User Content, these Terms, any sites or
            resources linked to the Service and/or our products and services included on or otherwise made available
            to you through the Service. You also agree to opt out of any class proceedings against Farmers Edge.
          </p>
          <p style={styles.parg}>
            You and Farmers Edge have required that these Terms and all documents relating thereto be drawn-up in
            English. Vous et Farmers Edge avez demandé que cette convention ainsi que tous les documents qui s’y
            rattachent soient rédigés en anglais.
          </p>
          <p style={styles.parg}>
            You consent to the exchange of information and documents between us electronically over the internet
            or by email. You agree that this electronic agreement shall be equivalent of a written paper
            agreement between us.
          </p>
          <p style={styles.parg}>
            Use of the Service is not authorized in any jurisdiction that does not give effect to all provisions
            of these Terms, including without limitation, this Section. You shall comply with all applicable domestic
            and international laws, statutes, ordinances and regulations regarding your use of the Service.
            Some jurisdictions may have restrictions on the use of the internet by their residents. You agree not to
            impersonate another person in your use of the Service or the sending of any e-mail to an address
            listed on the Website.
          </p>
          <p style={styles.bold}>
            17. General
          </p>
          <ol type='a' style={{...styles.list, ...styles.indent2}}>
            <li>
              <span style={styles.bold}>Entire Agreement. </span>
              These Terms, as they may be amended from time to time in accordance with the provisions of these Terms,
              and all other than existing transaction agreements between you and Farmers Edge, constitute and contains
              the entire agreement between you and Farmers Edge with respect to your use of the Service and with respect
              to the subject matter hereof and supersedes any prior oral or written agreements. In the event of a
              conflict between these Terms and any policies, rules or procedures posted on the Service, these Terms
              will prevail.
            </li>
            <li>
              <span style={styles.bold}>Relationship. </span>
              No agency, partnership, joint venture, employee-employer or franchiser-franchisee relationship is
              intended or created by these Terms.
            </li>
            <li>
              <span style={styles.bold}>Assignment and Enurement. </span>
              Farmers Edge may assign these Terms to any third party. These Terms cannot be assigned or transferred,
              in whole or in part, by you. These Terms will enure to the benefit of and be binding upon each of us
              and our respective successors, permitted assigns, heirs, executors and personal representatives.
            </li>
            <li>
              <span style={styles.bold}>No Waiver. </span>
              No waiver of any provision of these Terms shall be binding on Farmers Edge unless executed by
              Farmers Edge in writing. No waiver of any of the provisions of these Terms shall be deemed or
              shall constitute a waiver of any other provision (whether or not similar) nor shall such waiver
              constitute a continuing waiver unless otherwise expressly provided.  The failure of Farmers Edge
              to exercise or enforce any right or provision of these Terms shall not constitute a waiver of such
              right or provision.
            </li>
            <li>
              <span style={styles.bold}>Severability. </span>
              Any provision of these Terms which is held by a court of competent jurisdiction to be illegal,
              invalid or unenforceable in such jurisdiction shall, as to that jurisdiction, be ineffective to
              the extent of such illegality, invalidity or unenforceability and shall otherwise be enforced to
              the maximum extent permitted by law, all without affecting the remaining provisions of these Terms or
              affecting the legality, validity or enforceability of such provision in any other jurisdiction.
            </li>
          </ol>
          <p style={styles.bold}>
            18. Unsolicited Commercial Electronic Messages
          </p>
          <p style={styles.parg}>
            The inclusion of any email addresses on the Service is not consent to receiving unsolicited commercial
            electronic messages or SPAM.
          </p>
          <p style={styles.bold}>
            19. Acknowledgement
          </p>
          <p style={styles.parg}>
            I have read and accept all of the terms and conditions in these Terms.
          </p>
          <p style={styles.bold}>20. Contact Us</p>
          <p style={styles.parg}>If you have any questions, concerns or comments, please contact us at:</p>
          <section style={styles.parg}>
            <p style={styles.bold}>Farmers Edge Inc.</p>
            <p><span style={styles.bold}>Mailing Address:</span> 25 Rothwell Road, Winnipeg, MB R3P 2M5</p>
            <p><span style={styles.bold}>Telephone No.:</span> 1 (888) 576-6777</p>
            <p><span style={styles.bold}>E-mail:</span> support@farmersedge.ca</p>
          </section>
          <section style={styles.parg}>
            <p><span style={styles.bold}>Effective Date:</span> June 1, 2018
            </p>
          </section>
        </div>
        <div style={styles.buttons}>
          <FormField style={styles.formField}>
            <Button style={styles.button}
              raised
              primary
              onClick={this.onAccept}
            >
              I AGREE
            </Button>
            <Button style={styles.button}
              raised
              primary
              onClick={this.onReject}
            >
              I DISAGREE
            </Button>
          </FormField>
        </div>
      </div>
    )
  }
}

export default eulaContainer(Eula)
